export enum AlertTypes {
    SUCCESS = 'SUCCESS',
    DANGER  = 'DANGER',
    WARNING = 'WARNING',
    INFO    = 'INFO'
}
